import Settings from '@features/games/settings/settings';
export default Settings;
